import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-18597250"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex col",
  style: {"width":"400px","max-width":"80vw"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center align-center grow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"filter":"brightness(2%)"},
    src: "https://www.koovea.com/app/uploads/2022/12/Logo.svg"
  })
], -1))
const _hoisted_3 = { class: "flex col" }
const _hoisted_4 = {
  key: 0,
  class: "flex grow align-center justify-center"
}
const _hoisted_5 = {
  key: 1,
  class: "flex col g12 p24"
}
const _hoisted_6 = { class: "flex align-center justify-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "halftitle" }, "Koovea", -1))
const _hoisted_8 = { class: "flex align-center" }
const _hoisted_9 = { class: "flex col" }
const _hoisted_10 = { class: "flex col" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Identifiants", -1))
const _hoisted_12 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_13 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_14 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "30",
  style: {"filter":"brightness(5000%)"},
  src: "https://axeptio.imgix.net/2024/03/5c6381c8-ea28-4083-8d26-e7ab2e407837.png?auto=format&fit=crop&w=45&h=auto&dpr=2"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Connexion", -1))
const _hoisted_17 = { class: "flex col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Etiquette", -1))
const _hoisted_19 = { class: "flex align-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Etiquette Koovea :", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeLoadingIndicator = _resolveComponent("SeLoadingIndicator")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "kooveaModal",
      title: "Identifiants"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("form", _hoisted_3, [
            _createVNode(_component_SeInput, {
              modelValue: _ctx.kooveaEmail,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.kooveaEmail) = $event)),
              placeholderBase: "Nom de compte"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_SeInput, {
              modelValue: _ctx.kooveaPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kooveaPassword) = $event)),
              placeholderBase: "Mot de passe du compte",
              type: "password"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_SeButton, {
            ref: "kooveaBtn",
            onPress: _ctx.closeKooveaModal,
            class: "w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ok")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 512),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_SeLoadingIndicator)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_SeButton, {
              ref: "saveBtn",
              onPress: _ctx.save,
              icon: "ico/save.svg"
            }, null, 8, ["onPress"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.isDistributor)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Identifiants configurés par le distributeur"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "Identifiants configurés par l'établissement"))
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, "Pas de connexion a Koovea")),
                _createVNode(_component_SeButton, { onPress: _ctx.openKooveaModal }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["onPress"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  (_ctx.hasMasterRights())
                    ? (_openBlock(), _createBlock(_component_ReadonlyField, {
                        key: 0,
                        locked: _ctx.state.store.koovea_sticker != null
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SeDropdown, {
                            titleFunc: (sticker) => sticker.name,
                            ref: "hubSelect",
                            search: true,
                            modelValue: _ctx.state.selectedSticker,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.selectedSticker) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.kooveaStickers, (sticker) => {
                                return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                                  key: sticker.name,
                                  value: sticker
                                }, null, 8, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["titleFunc", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["locked"]))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _ctx.isLoggedIn]
                ])
              ])
            ])
          ])
        ]))
  ], 64))
}